import React from "react";
import styles from "./Loader.module.scss";
import CircularProgress from "@mui/material/CircularProgress";
function Loader() {
  return (
  
      <div className={styles.loader_container}>
        <CircularProgress />
      </div>
  
  );
}

export default Loader;
